import CalendarLtrFilled from 'mini-fluent-svg-icons/lib/icons/CalendarLtrFilled';
import CalendarLtrRegular from 'mini-fluent-svg-icons/lib/icons/CalendarLtrRegular';
import MailFilled from 'mini-fluent-svg-icons/lib/icons/MailFilled';
import MailRegular from 'mini-fluent-svg-icons/lib/icons/MailRegular';
import Module from 'mini-common-schema/lib/schema/Module';
import ModuleSwitcherItem from '../schema/ModuleSwitcherItem';
import PeopleFilled from 'mini-fluent-svg-icons/lib/icons/PeopleFilled';
import PeopleRegular from 'mini-fluent-svg-icons/lib/icons/PeopleRegular';
import { format } from 'owa-strings/utilities/format';
import { getDate, today } from 'owa-datetime';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';

export interface ModuleSwitcherIconRefs {
    mailIconRef?: React.RefObject<any>;
    calendarIconRef?: React.RefObject<any>;
    peopleIconRef?: React.RefObject<any>;
}

/**
 * Utility to get the items with their properties to be shown in the footer of the reading pane
 */
export default function getModuleSwitcherItems(
    iconRefs: ModuleSwitcherIconRefs,
    currentModule?: Module
): ModuleSwitcherItem[] {
    const strings = getOwaMiniCommonStrings();
    const { mailIconRef, calendarIconRef, peopleIconRef } = iconRefs || {};

    return [
        {
            moduleType: Module.Mail,
            icon: currentModule === Module.Mail ? MailFilled : MailRegular,
            label: strings.moduleMailLabel,
            ariaLabel: strings.moduleMailAriaLabel,
            ariaLabelWhenSelected: strings.moduleMailSelectedAriaLabel,
            iconRef: mailIconRef,
        },
        {
            moduleType: Module.Calendar,
            icon: currentModule === Module.Calendar ? CalendarLtrFilled : CalendarLtrRegular,
            label: strings.moduleCalendarLabel,
            ariaLabel: format(strings.moduleCalendarAriaLabel, getDate(today())),
            ariaLabelWhenSelected: format(
                strings.moduleCalendarSelectedAriaLabel,
                getDate(today())
            ),
            iconRef: calendarIconRef,
        },
        {
            moduleType: Module.People,
            icon: currentModule === Module.People ? PeopleFilled : PeopleRegular,
            label: strings.modulePeopleLabel,
            ariaLabel: strings.modulePeopleAriaLabel,
            ariaLabelWhenSelected: strings.modulePeopleSelectedAriaLabel,
            iconRef: peopleIconRef,
        },
    ];
}
